module.exports = __webpack_public_path__ + "img/g1.ad0ddc4e.png";